module.exports = __webpack_public_path__ + "img/jennifer_gibson_expert_exchanges_credit_likhaan_4.90a6967e.jpg";